import gql from "graphql-tag";

// Query
export const GET_REFERRAL = gql`
  query user($referral_indicated: String, $referral_indicator: String) {
    user(
      referral_indicated: $referral_indicated
      referral_indicator: $referral_indicator
    ) {
      created_at
      updated_at
      referral_indicated
      referral_value_indicated
      competence_payment_indicated
      power_plant_payment_indicated
      referral_indicator
      referral_value_indicator
      competence_payment_indicator
      power_plant_payment_indicator
    }
  }
`;

// // Query
// export const GET_USER_DETAIL = gql`
//     query user($customer_id: String!) {
//         user(customer_id: $customer_id) {
//             id
//             customer_id
//             buyer_id
//             name
//             email
//             cpf
//             date_of_birth
//             group
//             ID_document
//             last_invoice
//             marital_status
//             marital_type
//             nationality
//             payment_type
//             phone
//             gender
//             profession
//             requiredPSChange
//             partner_id
//             address {
//                 address
//                 address_number
//                 address_complement
//                 district
//                 postal_code
//                 state {
//                     name
//                     initials
//                 }
//                 city
//                 country {
//                     name
//                     initials
//                 }
//             }
//             lead {
//                 average_consumption
//             }
//             consumerunits {
//                 id
//                 customer_number
//                 installation_number
//                 percentage
//                 power_plant_id
//                 initial_average_comsumption
//             }
//             created_at
//             updated_at
//             card_default
//             payment_type
//             power_plants {
//               power_plant_id
//               name
//             }
//         }
//     }
// `;

// Query
export const GET_REFERRALS = gql`
  query referrals($orderBy: String) {
    referrals(orderBy: $orderBy) {
      created_at
      updated_at
      referral_indicated
      referral_value_indicated
      competence_payment_indicated
      power_plant_payment_indicated
      referral_indicator
      referral_value_indicator
      competence_payment_indicator
      power_plant_payment_indicator
      user_indicator {
        name
      }
      user_indicated {
        name
      }
    }
  }
`;

// Mutations
export const CREATE_REFERRAL = gql`
  mutation createReferral(
    $referral_indicated: String!
    $referral_value_indicated: Int!
    $referral_indicator: String!
    $referral_value_indicator: Int!
  ) {
    createReferral(
      referral: {
        referral_indicated: $referral_indicated
        referral_value_indicated: $referral_value_indicated
        referral_indicator: $referral_indicator
        referral_value_indicator: $referral_value_indicator
      }
    ) {
      id
    }
  }
`;

// Mutations
export const UPDATE_REFERRAL = gql`
  mutation updateReferral(
    $referral_indicated: String!
    $referral_value_indicated: Int!
    $competence_payment_indicated: String
    $power_plant_payment_indicated: String
    $referral_indicator: String!
    $referral_value_indicator: Int!
    $competence_payment_indicator: String
    $power_plant_payment_indicator: String
  ) {
    updateReferral(
      referral: {
        referral_indicated: $referral_indicated
        referral_value_indicated: $referral_value_indicated
        competence_payment_indicated: $competence_payment_indicated
        power_plant_payment_indicated: $power_plant_payment_indicated
        referral_indicator: $referral_indicator
        referral_value_indicator: $referral_value_indicator
        competence_payment_indicator: $competence_payment_indicator
        power_plant_payment_indicator: $power_plant_payment_indicator
      }
    ) {
      id
    }
  }
`;
